// extracted by css-extract-rspack-plugin
export default {"selfAssignButton":"AssigneesSection-module__selfAssignButton__ZU49Y7U"};